import {
  Mountain, Landmark, Home, Bus, Plane, Bird, Flower2, Compass, Waves,
} from "lucide-react";

export const SERVICE_LEVELS = [
  { id: "essential", name: "Essential", blurb: "Authentic, practical and value-focused." },
  { id: "comfort", name: "Comfort", blurb: "Improved stays, private transport and experienced guides." },
  { id: "signature", name: "Signature", blurb: "Premium stays, private arrangements and senior guides." },
];

// marker_type / module type -> visual meta
export const TYPE_META = {
  trek: { label: "Trekking", color: "#2B4C3E", icon: Mountain },
  trekking: { label: "Trekking", color: "#2B4C3E", icon: Mountain },
  culture: { label: "Culture", color: "#B7791F", icon: Landmark },
  heritage: { label: "Heritage", color: "#B7791F", icon: Landmark },
  accommodation: { label: "Stay", color: "#6B4E7A", icon: Home },
  transport: { label: "Transport", color: "#3A6FB0", icon: Bus },
  airport: { label: "Airport", color: "#3A6FB0", icon: Plane },
  wildlife: { label: "Wildlife", color: "#8A6D3B", icon: Bird },
  wellness: { label: "Wellness", color: "#3E6648", icon: Flower2 },
  adventure: { label: "Adventure", color: "#D95A40", icon: Compass },
  nature: { label: "Nature", color: "#3E6648", icon: Waves },
  city: { label: "City", color: "#5C5C54", icon: Landmark },
};

export const typeMeta = (t) => TYPE_META[t] || TYPE_META.adventure;

export const FILTERS = [
  { id: "all", label: "All" },
  { id: "trekking", label: "Trekking" },
  { id: "culture", label: "Culture" },
  { id: "wildlife", label: "Wildlife" },
  { id: "wellness", label: "Wellness" },
  { id: "adventure", label: "Adventure" },
  { id: "accommodation", label: "Stay" },
  { id: "transport", label: "Transport" },
];

export const FITNESS = ["Any", "None", "Low", "Medium", "High"];

export const MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

export const TRANSPORT_OPTIONS = [
  { mode: "flight", label: "Domestic Flight", price: 185, days: 0, time: "~45 min", note: "Fastest, weather dependent" },
  { mode: "private", label: "Private Vehicle", price: 120, days: 1, time: "~6-8 hrs", note: "Flexible & scenic" },
  { mode: "coach", label: "Tourist Coach", price: 35, days: 1, time: "~7-9 hrs", note: "Value option" },
];

// ISO A3 codes for highlighting country borders on the map
export const REGION_ISO = {
  nepal: ["NPL"],
  kyrgyzstan: ["KGZ"],
  kazakhstan: ["KAZ"],
  tajikistan: ["TJK"],
  uzbekistan: ["UZB"],
  "central-asia": ["KGZ", "KAZ", "TJK", "UZB"],
};
